var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeCounter"},[_c('span',[_vm._v(_vm._s(_vm.countDownList[0]))]),_vm._v("\n  :\n  "),_c('span',[_vm._v(_vm._s(_vm.countDownList[1]))]),_vm._v("\n  :\n  "),_c('span',[_vm._v(_vm._s(_vm.countDownList[2]))])])}
var staticRenderFns = []

export { render, staticRenderFns }